export default __webpack_public_path__ + "static/media/card.268acc46.png";